import type { SoftwareLocale } from "./software-contract";
export const softwareNavLabel: Record<string, string> = {
  it: "Software",
  en: "Software",
  es: "Software",
  fr: "Logiciels",
  de: "Software",
};
export const SOFTWARE_SLUGS: Record<string, string> = {
  it: "software",
  en: "software",
  es: "software",
  fr: "logiciels",
  de: "software",
};
export function softwarePath(locale: string, appId?: string) {
  return `/${locale}/${SOFTWARE_SLUGS[locale] ?? "software"}${appId ? `/${appId}` : ""}`;
}
export const softwareCopy: Record<
  SoftwareLocale,
  {
    title: string;
    description: string;
    catalog: string;
    free: string;
    registration: string;
    offline: string;
    download: string;
    unavailable: string;
    verify: string;
    verified: string;
    invalid: string;
    confirm: string;
    back: string;
    privacy: string;
    terms: string;
    usage: string;
    usageNote: string;
    version: string;
    settings: string;
    apps: string;
    licenses: string;
    downloads: string;
    activations: string;
    observed: string;
    events: string;
    save: string;
    error: string;
    notReady: string;
  }
> = {
  it: {
    title: "Software Enkey",
    description:
      "Sviluppiamo applicazioni e strumenti software. Scopri le applicazioni Enkey e le versioni disponibili.",
    catalog: "Applicazioni",
    free: "Gratuita con registrazione",
    registration:
      "Per attivare PCDiag servono nome o entità, email verificata, telefono con prefisso, località e nazione.",
    offline:
      "È prevista anche la prima attivazione offline tramite una licenza firmata ottenuta da un dispositivo con rete.",
    download: "Scarica per Windows",
    unavailable:
      "Il download della versione ufficiale sarà disponibile dopo il collaudo e la firma.",
    verify: "Verifica email",
    verified: "Email verificata. Torna nell’app e inserisci la key.",
    invalid:
      "Il link non è valido o è scaduto. Richiedi una nuova email dall’app.",
    confirm: "Conferma la verifica",
    back: "Torna a Enkey",
    privacy: "Privacy",
    terms: "Termini",
    usage: "Statistiche di utilizzo",
    usageNote:
      "Le statistiche facoltative descrivono soltanto l’utilizzo osservato. I report diagnostici restano sul PC.",
    version: "Versione",
    settings: "Configurazione",
    apps: "Applicazioni",
    licenses: "Licenze",
    downloads: "Download",
    activations: "Attivazioni online",
    observed: "Installazioni osservate",
    events: "Eventi osservati",
    save: "Salva",
    error: "Impossibile completare la richiesta.",
    notReady: "API di attivazione non abilitate",
  },
  en: {
    title: "Enkey Software",
    description:
      "We develop applications and software tools. Explore Enkey applications and available releases.",
    catalog: "Applications",
    free: "Free with registration",
    registration:
      "PCDiag activation requires a name or organisation, verified email, phone with country code, town and country.",
    offline:
      "First activation offline is also planned using a signed licence obtained from a connected device.",
    download: "Download for Windows",
    unavailable:
      "The official download will be available after testing and signing.",
    verify: "Verify email",
    verified: "Email verified. Return to the app and enter your key.",
    invalid:
      "This link is invalid or expired. Request a new email from the app.",
    confirm: "Confirm verification",
    back: "Back to Enkey",
    privacy: "Privacy",
    terms: "Terms",
    usage: "Usage statistics",
    usageNote:
      "Optional statistics describe observed usage only. Diagnostic reports remain on your PC.",
    version: "Version",
    settings: "Settings",
    apps: "Applications",
    licenses: "Licences",
    downloads: "Downloads",
    activations: "Online activations",
    observed: "Observed installations",
    events: "Observed events",
    save: "Save",
    error: "The request could not be completed.",
    notReady: "Activation API disabled",
  },
  es: {
    title: "Software Enkey",
    description:
      "Desarrollamos aplicaciones y herramientas de software. Descubre las aplicaciones Enkey y sus versiones disponibles.",
    catalog: "Aplicaciones",
    free: "Gratis con registro",
    registration:
      "Para activar PCDiag se necesitan nombre o entidad, email verificado, teléfono con prefijo, localidad y país.",
    offline:
      "También se prevé la primera activación sin conexión mediante una licencia firmada obtenida desde un dispositivo conectado.",
    download: "Descargar para Windows",
    unavailable:
      "La descarga oficial estará disponible después de las pruebas y la firma.",
    verify: "Verificar email",
    verified: "Email verificado. Vuelve a la aplicación e introduce la clave.",
    invalid:
      "El enlace no es válido o ha caducado. Solicita otro email desde la aplicación.",
    confirm: "Confirmar verificación",
    back: "Volver a Enkey",
    privacy: "Privacidad",
    terms: "Condiciones",
    usage: "Estadísticas de uso",
    usageNote:
      "Las estadísticas opcionales describen solo el uso observado. Los informes de diagnóstico permanecen en el PC.",
    version: "Versión",
    settings: "Configuración",
    apps: "Aplicaciones",
    licenses: "Licencias",
    downloads: "Descargas",
    activations: "Activaciones en línea",
    observed: "Instalaciones observadas",
    events: "Eventos observados",
    save: "Guardar",
    error: "No se pudo completar la solicitud.",
    notReady: "API de activación deshabilitada",
  },
  fr: {
    title: "Logiciels Enkey",
    description:
      "Nous développons des applications et des outils logiciels. Découvrez les applications Enkey et les versions disponibles.",
    catalog: "Applications",
    free: "Gratuit avec inscription",
    registration:
      "L’activation de PCDiag nécessite un nom ou organisme, un email vérifié, un téléphone avec indicatif, une ville et un pays.",
    offline:
      "Une première activation hors ligne est également prévue avec une licence signée obtenue depuis un appareil connecté.",
    download: "Télécharger pour Windows",
    unavailable:
      "Le téléchargement officiel sera disponible après les tests et la signature.",
    verify: "Vérifier l’email",
    verified:
      "Email vérifié. Retournez dans l’application et saisissez la clé.",
    invalid:
      "Ce lien est invalide ou expiré. Demandez un nouvel email depuis l’application.",
    confirm: "Confirmer la vérification",
    back: "Retour à Enkey",
    privacy: "Confidentialité",
    terms: "Conditions",
    usage: "Statistiques d’utilisation",
    usageNote:
      "Les statistiques facultatives décrivent uniquement l’utilisation observée. Les rapports de diagnostic restent sur le PC.",
    version: "Version",
    settings: "Configuration",
    apps: "Applications",
    licenses: "Licences",
    downloads: "Téléchargements",
    activations: "Activations en ligne",
    observed: "Installations observées",
    events: "Événements observés",
    save: "Enregistrer",
    error: "Impossible de terminer la demande.",
    notReady: "API d’activation désactivée",
  },
  de: {
    title: "Enkey Software",
    description:
      "Wir entwickeln Anwendungen und Softwarewerkzeuge. Entdecken Sie Enkey Anwendungen und verfügbare Versionen.",
    catalog: "Anwendungen",
    free: "Kostenlos mit Registrierung",
    registration:
      "Für PCDiag sind Name oder Organisation, bestätigte E-Mail, Telefonnummer mit Vorwahl, Ort und Land erforderlich.",
    offline:
      "Die erste Offline-Aktivierung ist ebenfalls mit einer signierten Lizenz von einem verbundenen Gerät vorgesehen.",
    download: "Für Windows herunterladen",
    unavailable:
      "Der offizielle Download wird nach Tests und Signierung verfügbar sein.",
    verify: "E-Mail bestätigen",
    verified:
      "E-Mail bestätigt. Kehren Sie zur App zurück und geben Sie den Schlüssel ein.",
    invalid:
      "Dieser Link ist ungültig oder abgelaufen. Fordern Sie eine neue E-Mail in der App an.",
    confirm: "Bestätigung abschließen",
    back: "Zurück zu Enkey",
    privacy: "Datenschutz",
    terms: "Bedingungen",
    usage: "Nutzungsstatistiken",
    usageNote:
      "Optionale Statistiken beschreiben nur die beobachtete Nutzung. Diagnoseberichte bleiben auf dem PC.",
    version: "Version",
    settings: "Einstellungen",
    apps: "Anwendungen",
    licenses: "Lizenzen",
    downloads: "Downloads",
    activations: "Online-Aktivierungen",
    observed: "Beobachtete Installationen",
    events: "Beobachtete Ereignisse",
    save: "Speichern",
    error: "Die Anfrage konnte nicht abgeschlossen werden.",
    notReady: "Aktivierungs-API deaktiviert",
  },
};
